import { View } from 'backbone.marionette';
import Ladda from 'ladda';

import showSuccessMessage from '@/util/ShowSuccessMessage';
import showErrorMessage from '@/util/showErrorMessage';
import { parseServerDateTime, formatDisplayDateTime } from '@/util/MomentUtils';
import showModal from '@/util/showModal';

import ApproveUserCommandMembership from '../../services/ApproveUserCommandMembership';
import MembershipRejectionReasonModalView from '../MembershipRejectionReasonModalView';

import tmplMembershipApprovalDetailsModalView from './MembershipApprovalDetailsModalView.hbs';

const MembershipApprovalDetailsModalView = View.extend({
  template: tmplMembershipApprovalDetailsModalView,

  ui: {
    btnApprove: '.btn-approve',
    btnReject: '.btn-reject'
  },

  events: {
    'click @ui.btnApprove': 'approveMembership',
    'click @ui.btnReject': 'rejectMembership'
  },

  onBeforeRender() {
    let approvalRequestDate = this.model.get('date');
    approvalRequestDate = formatDisplayDateTime(parseServerDateTime(approvalRequestDate));
    this.model.set('approvalRequestDate', approvalRequestDate);
  },

  showApprovalSuccessMessage() {
    showSuccessMessage({
      code: 'approvalSuccess',
      title: 'Approval Success',
      message: 'User has been approved',
      hideAfter: 5
    });
  },

  showApprovalErrorMessage() {
    showErrorMessage({
      errorCode: 'approvalError',
      errorTitle: 'Approval Error',
      errorMessage: 'An error occurred while approving user.'
    });
  },

  showExternalUserCancelledRequestMessage() {
    showErrorMessage({
      errorCode: 'cancellationError',
      errorTitle: 'Customer Cancelled Command Access Request',
      errorMessage: 'Request for command access has already been removed.'
    });
  },

  toggleForm(state = true) {
    this.ui.btnApprove.prop('disabled', !state);
    this.ui.btnReject.prop('disabled', !state);
  },

  async approveMembership(e) {
    e.preventDefault();
    const notificationId = this.model.get('id');
    const spinner = Ladda.create(this.ui.btnApprove[0]);
    this.toggleForm(false);

    try {
      spinner.start();
      await ApproveUserCommandMembership(notificationId);
      this.showApprovalSuccessMessage();
      this.closeModal(this.model);
    } catch (err) {
      if (err.message.string === 'COMMAND_REMOVED') {
        this.showExternalUserCancelledRequestMessage();
        this.closeModal(this.model);
      } else {
        this.showApprovalErrorMessage();
      }
    } finally {
      this.toggleForm();
      spinner.stop();
    }
  },

  async rejectMembership(e) {
    e.preventDefault();
    await showModal({
      title: 'Membership Rejection',
      view: new MembershipRejectionReasonModalView({
        model: this.model
      }),
      dialogClasses: 'modal-lg'
    });
    this.closeModal(this.model);
  },

  closeModal(model) {
    this.triggerMethod('modal:close', model);
  }
});

export default MembershipApprovalDetailsModalView;
